import React, { useEffect, useState } from "react";
import { EquipmentMasterApi } from "../../api/backend/equipmentMaster";
import SelectWithLabel from "../../component/FormInput/SelectWithLabel";
import FolderTreeComponent from "../../component/tree-folder/TreeFolderComponent";
import { lang } from "../../constants/common.const";
import { handleCatchError } from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import { findParent, transformData } from "../../utils/treeFolder";

const ModalSelectCategory = ({
  onSelect,
  initFilter,
  setCategoryType = () => {},
  listSelects = [],
  listExpands = [],
  setListSelects = () => {},
  setListExpands = () => {},
}) => {
  const [filterCate, setFilterCate] = useState(new classDdl());
  const [data, setData] = useState([]);

  useEffect(() => {
    if (initFilter) {
      setFilterCate(initFilter);
      getTreeCategory(initFilter.value);
      setCategoryType(initFilter.value);
    }
  }, [initFilter]);
  const getTreeCategory = async (value) => {
    try {
      const res = await EquipmentMasterApi.getTree({
        typeKey: value,
      });
      setData(res.data);
    } catch (error) {
      handleCatchError(error);
    }
  };

  const treeData = transformData(data, "", listExpands);

  const handleSelect = (_, info) => {
    const node = info.node || {};
    const listParent = findParent(treeData, node.key, []);
    let name = node.name;
    if (listParent && Array.isArray(listParent) && listParent.length) {
      listParent.shift();
      name = listParent
        .map((i) => i.name)
        .concat(node.name)
        .join(" / ");
    }
    onSelect({
      value: node.id,
      label: name,
      order: node.order,
      haveChildren:
        node.children &&
        Array.isArray(node.children) &&
        node.children.length > 0,
        class:filterCate.value
    });
  };
  return (
    <div>
      <div className="mt mb10">
        <SelectWithLabel
          disabled={true}
          label={lang.TYPE_OF_WORK}
          value={filterCate.value}
          onChange={(e) => {
            setFilterCate({ ...filterCate, value: e });
            getTreeCategory(e);
            setListExpands([]);
            setListSelects([]);
          }}
          className="w100 mb10"
          options={filterCate.options}
        ></SelectWithLabel>
      </div>
      <FolderTreeComponent
        currentKey={filterCate.value}
        onSelect={handleSelect}
        data={treeData}
        listSelects={listSelects}
        listExpands={listExpands}
        setListSelects={setListSelects}
        setListExpands={setListExpands}
      />
    </div>
  );
};

export default ModalSelectCategory;
